export type { CompanyHomeProps } from './company-home';
export * from './company-home.routes';

export { default as CompanyHome, default } from './company-home';
